import { ReactNode } from 'react';
import classNames from 'classnames';
import './ContentLayout.scss';

interface ContentLayoutProps {
    children: ReactNode;
    className?: string;
    gap?: number;
    includeSeparator?: boolean;
}

export function ContentLayout({
    children,
    className,
    gap,
    includeSeparator = false,
}: ContentLayoutProps) {
    return (
        <div
            className={classNames('ContentLayout', className, {
                'ContentLayout--separated': includeSeparator,
            })}
            style={{ '--gap': gap }}
        >
            {children}
        </div>
    );
}
